import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const CardContainer = styled(motion.div)(({ theme, isSelected }) => ({
  backgroundColor: isSelected ? '#EDAFB8' : '#F7E1D7',
  borderRadius: '12px',
  padding: '16px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  position: 'relative',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
}));

const CustomCheckbox = styled(Box)(({ isSelected }) => ({
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  border: `2px solid ${isSelected ? '#fff' : '#EDAFB8'}`,
  backgroundColor: isSelected ? '#EDAFB8' : 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '8px',
  transition: 'all 0.2s ease',
  '&::after': {
    content: isSelected ? '"✓"' : '""',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 'bold'
  }
}));

export default function JuzCard({ 
  index, 
  isSelected, 
  juzData, 
  onClick, 
  onRemove,
  isCreator,
  isFirstIncomplete 
}) {
  if (!juzData) {
    return (
      <CardContainer
        isSelected={isSelected}
        onClick={onClick}
        className={isFirstIncomplete ? 'hatm-first-incomplete-juz' : ''}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CustomCheckbox isSelected={isSelected} />
          <Typography variant="subtitle1" sx={{ color: isSelected ? '#fff' : '#333A3B' }}>
            {index}. Cüz
          </Typography>
        </Box>
      </CardContainer>
    );
  }

  const handleRemoveClick = (e) => {
    e.stopPropagation();
    onRemove(index);
  };

  return (
    <CardContainer
      isSelected={isSelected}
      onClick={onClick}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.2 }}
      className={isFirstIncomplete ? 'hatm-first-incomplete-juz' : ''}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!juzData && <CustomCheckbox isSelected={isSelected} />}
          <Typography variant="subtitle1" sx={{ color: isSelected ? '#fff' : '#333A3B' }}>
            {index}. Cüz
          </Typography>
        </Box>
        
        {juzData && isCreator && (
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={handleRemoveClick}
            style={{
              background: 'none',
              border: 'none',
              color: '#ff4444',
              cursor: 'pointer',
              padding: '4px',
            }}
          >
            ✕
          </motion.button>
        )}
      </Box>

      {juzData && (
        <Typography 
          variant="body2" 
          sx={{ 
            mt: 1,
            color: '#555',
            fontSize: '0.875rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {juzData.fullName}
        </Typography>
      )}
    </CardContainer>
  );
} 